import { render, staticRenderFns } from "./PdvProductSearch.vue?vue&type=template&id=d345c184"
import script from "./PdvProductSearch.vue?vue&type=script&lang=js"
export * from "./PdvProductSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports